import type { District } from '../plot.ts'
import { decals, look } from '../kit.ts'

/** Neon City: towers, crosswalks, konbini and the arcade. Best after dark. */
export const city: District = {
  id: 'city',
  name: 'Neon City',
  ground: 'asphalt',
  build(p) {
    // Four blocks of sidewalk; the asphalt left between them is the streets.
    p.zone(1, 1, 14, 12, 'sidewalk'); p.zone(20, 1, 15, 12, 'sidewalk'); p.zone(1, 18, 14, 13, 'sidewalk'); p.zone(20, 18, 15, 13, 'sidewalk')
    p.prop(
      { kind: 'gate', x: 0, y: 13, w: 1, d: 5, variant: 'neon', text: 'NEON CITY' },
      { kind: 'crosswalk', x: 15, y: 9, w: 5, d: 2 }, { kind: 'crosswalk', x: 15, y: 20, w: 5, d: 2 },
      { kind: 'crosswalk', x: 10, y: 13, w: 2, d: 5 }, { kind: 'crosswalk', x: 23, y: 13, w: 2, d: 5 },
      // North-west block.
      { kind: 'building', x: 2, y: 2, w: 6, d: 6, style: 'tower', h: 9, color: '#8fa6ff', roof: '#4a5a9c', text: 'HOTEL' },
      { kind: 'building', x: 9, y: 2, w: 5, d: 4, style: 'shop', color: '#ffe3ee', roof: '#ff8fab', text: 'Konbini' },
      { kind: 'building', x: 9, y: 7, w: 5, d: 4, style: 'shop', color: '#fff1c2', roof: '#e0a030', text: 'Ramen' },
      // North-east block.
      { kind: 'building', x: 21, y: 2, w: 6, d: 6, style: 'tower', h: 12, color: '#9fe3d0', roof: '#3f8f7a', text: 'BLOBNET' },
      { kind: 'building', x: 28, y: 2, w: 6, d: 5, style: 'tower', h: 7, color: '#ffd9a8', roof: '#b07040' },
      { kind: 'tree', x: 22, y: 10 }, { kind: 'tree', x: 26, y: 10 }, { kind: 'tree', x: 30, y: 10 },
      // South-west block: the arcade.
      { kind: 'building', x: 2, y: 19, w: 6, d: 6, style: 'shop', h: 4, door: 3, color: '#4a3f86', roof: '#b07bff', text: 'Pixel Pit', enter: 'arcade' },
      { kind: 'building', x: 9, y: 19, w: 5, d: 4, style: 'shop', color: '#d6f5ff', roof: '#4fc3f7', text: 'Bubble Tea' },
      { kind: 'building', x: 9, y: 25, w: 5, d: 5, style: 'tower', h: 8, color: '#c9b8e8', roof: '#6c5ce7' },
      // South-east block.
      { kind: 'building', x: 21, y: 19, w: 7, d: 7, style: 'tower', h: 14, color: '#b7c3d6', roof: '#2d3a55', text: 'BLOBCORP' },
      { kind: 'building', x: 29, y: 19, w: 5, d: 4, style: 'shop', color: '#e3f2e6', roof: '#5aa9c9', text: 'Books' },
      { kind: 'statue', x: 31, y: 27 }, { kind: 'bench', x: 24, y: 28, face: 1 },
      // Street furniture.
      { kind: 'trafficlight', x: 14, y: 12 }, { kind: 'trafficlight', x: 20, y: 12 }, { kind: 'trafficlight', x: 14, y: 18 }, { kind: 'trafficlight', x: 20, y: 18 },
      { kind: 'streetlamp', x: 14, y: 4 }, { kind: 'streetlamp', x: 20, y: 4 }, { kind: 'streetlamp', x: 14, y: 27 }, { kind: 'streetlamp', x: 20, y: 27 },
      { kind: 'streetlamp', x: 5, y: 12 }, { kind: 'streetlamp', x: 29, y: 12 }, { kind: 'streetlamp', x: 5, y: 18 }, { kind: 'streetlamp', x: 29, y: 18 },
      { kind: 'hydrant', x: 14, y: 7 }, { kind: 'hydrant', x: 20, y: 24 },
      { kind: 'car', x: 15, y: 2, rot: 1, color: '#ff6b6b' }, { kind: 'car', x: 19, y: 26, rot: 1, color: '#4fc3f7' },
      { kind: 'car', x: 3, y: 13, color: '#ffd166' }, { kind: 'car', x: 28, y: 17, color: '#7cf29c' },
    )
    p.tram(3, 28)
    p.place({ id: 'city', name: 'Neon City', blurb: 'Towers, crosswalks, bubble tea and the arcade. Best after dark.', x: 17, y: 15, accent: '#b07bff', r: 12 })
    p.critter({ kind: 'pigeon', loop: [[6.5, 13.5], [12, 14.2], [8, 16.5]], speed: 0.6 })
    p.npc({
      id: 'npc-rush', name: 'Rush', role: 'Commuter', look: look('rushhour', 2, 16, 4, 'cap'), speed: 2.8,
      stops: [{ x: 17, y: 2, wait: 3, say: -1 }, { x: 17, y: 29, wait: 3 }, { x: 2, y: 15, wait: 3, say: -1 }, { x: 33, y: 15, wait: 3 }],
      lines: ['Late, late, late!', 'Sorry! Coming through!', 'Can’t stop, meeting at Blobcorp.', 'Is the tram running?'],
    })
    p.npc({
      id: 'npc-busker', name: 'Busker Bo', role: 'Musician', look: look('buskerbo', 5, 12, 2, 'headphones'), speed: 1,
      stops: [{ x: 7, y: 26, wait: 40, emote: 'happy', say: -1 }, { x: 12, y: 16, wait: 30, emote: 'smug', say: -1 }],
      lines: ['♪ la la blob ♪', 'Tips welcome. Compliments preferred.', 'This one is called “Neon Rain”.', 'The arcade has a dance floor, you know.'],
    })

    // ─── Detail ───
    // Lane markings down the middle of both streets, skipping the crossing and crosswalks.
    for (let y = 0; y < 32; y += 2) if ((y < 8 || y > 22) && (y < 12 || y > 18)) p.prop({ kind: 'decal', x: 17, y, variant: 'roadline-y' })
    for (let x = 0; x < 36; x += 2) if (!(x >= 9 && x <= 25)) p.prop({ kind: 'decal', x, y: 15, variant: 'roadline' })
    p.scatter(decals(['manhole', 'crack', 'crack'], 0.03, ['asphalt']))
    p.scatter(decals(['crack', 'puddle'], 0.02, ['sidewalk']))
    p.prop(
      { kind: 'vending', x: 8, y: 11, color: '#ff5d8f' }, { kind: 'bin', x: 1, y: 12 }, { kind: 'bin', x: 34, y: 12 }, { kind: 'bin', x: 1, y: 18 },
      { kind: 'bicycle', x: 13, y: 24, color: '#ffd166' }, { kind: 'bicycle', x: 12, y: 24, color: '#ff6b6b' },
      { kind: 'aboard', x: 13, y: 11, text: 'Ramen' }, { kind: 'aboard', x: 13, y: 23, text: 'Boba' },
      { kind: 'bollard', x: 20, y: 13 }, { kind: 'bollard', x: 14, y: 13 }, { kind: 'bollard', x: 20, y: 17 }, { kind: 'bollard', x: 14, y: 17 },
      { kind: 'pot', x: 28, y: 26, variant: 'tree' }, { kind: 'pot', x: 33, y: 26, variant: 'tree' },
      { kind: 'cart', x: 22, y: 12, color: '#ff8fab', text: 'Crêpes' },
    )
    // Traffic: two lanes each way, looping just past the plot's edges.
    p.critter({ kind: 'car', color: '#ff6b6b', loop: [[16.3, -2], [16.3, 33]], speed: 2.6 })
    p.critter({ kind: 'car', color: '#4fc3f7', loop: [[18.7, 33], [18.7, -2]], speed: 2.2 })
    p.critter({ kind: 'car', color: '#ffd166', loop: [[-2, 14.3], [37, 14.3]], speed: 2.4 })
    p.critter({ kind: 'car', color: '#7cf29c', loop: [[37, 16.7], [-2, 16.7]], speed: 2.8 })
    p.critter({ kind: 'car', color: '#b07bff', loop: [[18.7, 20], [18.7, -2], [18.7, 33]], speed: 2 })
    p.npc({
      id: 'npc-oli', name: 'Oli', role: 'Office worker', look: look('officeoli', 2, 15, 1, 'tophat'), speed: 1.6,
      stops: [{ x: 24, y: 27, wait: 12, say: -1 }, { x: 11, y: 12, wait: 10, emote: 'happy' }, { x: 6, y: 9, wait: 8, say: -1 }],
      lines: ['Lunch break! Ramen again.', 'Blobcorp is hiring. It’s always hiring.', 'Coffee, then spreadsheets, then coffee.'],
    })
    p.npc({
      id: 'npc-sky', name: 'Sky', role: 'Skater', look: look('skatersky', 9, 18, 4, 'cap'), speed: 3,
      stops: [{ x: 33, y: 13, wait: 2 }, { x: 2, y: 13, wait: 2, emote: 'smug' }, { x: 2, y: 17, wait: 2 }, { x: 33, y: 17, wait: 3, say: -1 }],
      lines: ['Kickflip! …almost.', 'The crosswalks have the best grip.', 'Race you to the arcade!'],
    })
  },
}
